import { render, staticRenderFns } from "./SettingRouteBox.vue?vue&type=template&id=eafdfd18&scoped=true"
import script from "./SettingRouteBox.vue?vue&type=script&lang=js"
export * from "./SettingRouteBox.vue?vue&type=script&lang=js"
import style0 from "./SettingRouteBox.vue?vue&type=style&index=0&id=eafdfd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafdfd18",
  null
  
)

export default component.exports